export { default as ProductDetailsPage } from './ProductDetailsPage';
